<template>
  <!-- 话务管理-语音留言 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="menuLeft">
        <AudioBar v-if="audioInfo" :audioInfo="audioInfo"></AudioBar>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <el-button
          v-if="permissionList.dealBtn && row.handleStatus == 0"
          type="text"
          size="small"
          @click="openDialog('deal', row)"
        >
          处理
        </el-button>
        <el-button
          v-if="permissionList.downloadBtn"
          type="text"
          size="small"
          @click="dealOperation(row)"
        >
          下载
        </el-button>
      </template>
      <template slot="dateRangeSearch">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 100%"
        >
        </el-date-picker>
      </template>
      <template slot="radio" slot-scope="{ row }">
        <el-radio v-model="selectRowIndex" :label="row.$index" @change="rowClick(row)">
          <span>{{ '' }}</span>
        </el-radio>
      </template>
    </avue-crud>
    <!-- 弹框 -->
    <el-dialog
      :title="dialogTitle"
      width="40%"
      :visible.sync="isDialogShow"
      :before-close="beforeCloseDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <Deal :rowData="rowData" @update="updateTableDataSuccess" @close="beforeCloseDialog"></Deal>
    </el-dialog>
  </basic-container>
</template>

<script>
import AudioBar from '../../components/audio-bar';
import Deal from './deal-dialog';
import { mapGetters } from 'vuex';
import { getProjectListApi } from '@/api/call-system/index';
import { getPageListApi } from '@/api/call-system/call-manage/voice-message';

export default {
  components: {
    AudioBar,
    Deal,
  },
  data() {
    return {
      oldProjectId: '', // 旧项目id，重置搜索条件和新增时需要使用
      projectList: [], // 项目列表
      dialogType: '', // 弹框的类型
      dialogTitle: '', // 弹框显示的标题
      isDialogShow: false, // 弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      searchForm: {}, // 搜索条件
      dateRange: [], // 搜索条件-起止日期
      selectRowIndex: -1, // 选中的行在当前页的序号
      audioInfo: null, // 选中的行对应的数据
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        dialogClickModal: false,
        searchMenuSpan: 6,
        searchLabelWidth: 100,
        menuWidth: 160,
        column: [
          {
            label: '选择',
            prop: 'radio',
            width: 50,
            slot: true,
          },
          {
            label: '项目名称',
            prop: 'projectId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            hide: true,
            showColumn: false,
            display: false,
            // search: true,
            // searchClearable: false,
          },
          {
            label: '来电号码',
            prop: 'incomingTel',
          },
          {
            label: '来电时间',
            prop: 'incomingTime',
          },
          {
            label: '留言时长',
            prop: 'audioDuration',
          },
          {
            label: '处理人',
            prop: 'handleServiceName',
          },
          {
            label: '处理时间',
            prop: 'handleTime',
          },
          {
            label: '处理说明',
            prop: 'handleMessage',
          },
          {
            label: '处理状态',
            prop: 'handleStatus',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=call_leavemsg_handle_status',
            props: { label: 'dictValue', value: 'dictKey' },
            display: false,
            showColumn: false,
            search: true,
          },
          {
            label: '起止日期',
            prop: 'dateRange',
            display: false,
            showColumn: false,
            search: true,
            searchslot: true,
            searchSpan: 12,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        downloadBtn: this.vaildData(
          this.permission.callSystem_callManage_voiceMessage_download,
          false
        ),
        dealBtn: this.vaildData(this.permission.callSystem_callManage_voiceMessage_deal, false),
      };
    },
  },
  created() {
    getProjectListApi().then(({ data }) => {
      this.projectList = data || [];
      if (this.projectList.length > 0) {
        this.findObject(this.tableOption.column, 'projectId').dicData = this.projectList;
        this.searchForm.projectId = this.projectList[0].id;
        this.loadData();
      }
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 340; // 表格区域初始化高度
      const searchH = 56; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      if (!this.searchForm.projectId) return;
      this.oldProjectId = this.searchForm.projectId;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.selectRowIndex = -1;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.selectRowIndex = -1;
      this.dateRange = [];
      this.searchForm = {
        projectId: this.oldProjectId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.selectRowIndex = -1;
      this.searchForm = params;
      this.dealDateRange();
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 转化日期范围 */
    dealDateRange() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.incomingTimeBegin = this.dayjs(this.dateRange[0]).format('YYYY-MM-DD');
        this.searchForm.incomingTimeEnd = this.dayjs(this.dateRange[1]).format('YYYY-MM-DD');
      } else {
        this.searchForm.incomingTimeBegin = '';
        this.searchForm.incomingTimeEnd = '';
        this.dateRange = [];
      }
    },
    /* 行点击 */
    rowClick(row) {
      this.selectRowIndex = row.$index;
      this.audioInfo = this.tableData[this.selectRowIndex];
    },
    /* 表格数据更新成功 */
    updateTableDataSuccess() {
      this.loadData();
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 操作：下载 */
    dealOperation(row) {
      window.open(row.audioUrl);
    },
    /* 打开弹框 */
    openDialog(type, rowData = {}) {
      let titles = {
        deal: '语音留言处理',
      };
      this.dialogTitle = titles[type];
      this.dialogType = type;
      this.rowData = rowData;
      this.needCloseConfirm = false;
      this.isDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.dialogType = '';
          this.isDialogShow = false;
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.dialogType = '';
              this.isDialogShow = false;
            }
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
